import type { OptimizedSources } from '@farmersdog/corgi-x';
import { Nowrap } from '@farmersdog/corgi-x';
import { sources } from './assets';

type PressBarItem = {
  sources: OptimizedSources;
  alt: string;
  height: {
    mobile: number;
    desktop: number;
  };
  quote: JSX.Element | string;
  ariaLabel: string;
};

export const pressBarItems: PressBarItem[] = [
  {
    sources: sources.popularScience,
    alt: 'Popular Science Logo',
    height: {
      mobile: 28,
      desktop: 36,
    },
    quote: (
      <>
        The Farmer’s Dog is working to combat poor health with fresh,{' '}
        <Nowrap>human-grade food</Nowrap>
      </>
    ),
    ariaLabel:
      'Popular Science: The Farmer’s Dog is working to combat poor health with fresh, human-grade food',
  },
  {
    sources: sources.goodHousekeeping,
    alt: 'Good Housekeeping Logo',
    height: {
      mobile: 28,
      desktop: 36,
    },
    quote: (
      <>
        Helps you zero in on everything you need to consider for{' '}
        <Nowrap>your dog</Nowrap>
      </>
    ),
    ariaLabel:
      'Good Housekeeping: Helps you zero in on everything you need to consider for your dog',
  },
  {
    sources: sources.google,
    alt: 'Google customer reviews five stars',
    height: {
      mobile: 28,
      desktop: 36,
    },
    quote: (
      <>
        My dog LOVES the food and I love the convenience and{' '}
        <Nowrap>nutritional value!</Nowrap>
      </>
    ),
    ariaLabel:
      'Google customer reviews: My dog LOVES the food and I love the convenience and nutritional value!',
  },
  {
    sources: sources.newYorkMagazine,
    alt: 'New York Magazine Logo',
    height: {
      mobile: 28,
      desktop: 36,
    },
    quote:
      'Ongoing long-term feeding trials show that its food exceeds AAFCO recommendations',
    ariaLabel:
      'New York Magazine: Ongoing long-term feeding trials show that its food exceeds AAFCO recommendations',
  },
  {
    sources: sources.cnet,
    alt: 'CNET Logo',
    height: {
      mobile: 22,
      desktop: 28,
    },
    quote: (
      <>
        A personalized profile and diet based on breed, age, activity level,{' '}
        <Nowrap>ideal weight</Nowrap>
      </>
    ),
    ariaLabel:
      'CNET: A personalized profile and diet based on breed, age, activity level, ideal weight',
  },
];
